export default __webpack_public_path__ + "static/banner-image-35b12fbea35e767ac33b8973bcbcea03.png";